import React from 'react'
import classnames from 'classnames'

import styles from './progress.module.scss'

interface Props {
  className?: string
  value: number
  max?: number
  height?: number
  text?: string
  stripe?: boolean
  color?: string
}

const ProgressBar = ({
  className = '',
  value,
  max = 100,
  height = 20,
  text = '',
  stripe = false,
  color = '',
}: Props) => {
  // eslint-disable-next-line no-mixed-operators
  const percentage = Math.floor((value / max) * 1000) / 10
  const colorStyle = color && styles[color] ? styles[color] : ''
  return (
    <div
      className={classnames(styles.progressBar, className)}
      style={{ height }}
    >
      <div
        className={classnames(
          `${styles.value} ${styles.transition}`,
          colorStyle,
          {
            [styles.stripe]: stripe,
          },
        )}
        style={{ width: `${percentage}%` }}
      >
        {text && <div className={`${styles.text} tx-right tx-12`}>{text}</div>}
      </div>
    </div>
  )
}

export default ProgressBar
